import React, { useState, useContext } from "react";
import classnames from "classnames";
import { Input, Text, MobileContext } from "components/common";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import axios from "axios";
import { track } from "../../../../../utils/analytics";

const md5 = require("md5");

function Password({ user, SettingsButton, SettingsInputContainer }) {
  const { isMobile } = useContext(MobileContext);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [inProgress, setInProgress] = useState(false);
  // const [isUpdated, setIsUpdated] = useState(false);
  const [passwordReset, setPasswordReset] = useState(false);
  const [updatePassword] = useMutation(UPDATE_PASSWORD);

  const triggerResetEmail = () => {
    console.log("triggered");
    setPasswordReset(true);
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/passwordrecovery`, {
      email: user.email
    });
  };

  return (
    <div className="mt-4">
      <SettingsInputContainer className="mb-3" style={{ maxWidth: "400px" }}>
        <Input
          placeholder="Current password"
          value={oldPassword}
          onChange={e => {
            setOldPassword(e.target.value);
          }}
          type="password"
        />
      </SettingsInputContainer>
      <SettingsInputContainer className="mb-3" style={{ maxWidth: "400px" }}>
        <Input
          placeholder="New password"
          value={newPassword}
          onChange={e => {
            setNewPassword(e.target.value);
          }}
          type="password"
        />
      </SettingsInputContainer>
      <Text className={errorMessage ? "" : "hidden"}>{errorMessage}</Text>
      <SettingsButton
        disabled={!oldPassword || !newPassword}
        onClick={e => {
          setInProgress(true);
          setErrorMessage("");
          const oldpw = md5(oldPassword);
          const newpw = md5(newPassword);
          track("DASHBOARD_SETTINGS_PASSWORD_CHANGE_SUBMITTED");
          return updatePassword({
            variables: {
              user_id: user.email,
              old_password: oldpw,
              new_password: newpw
            },
            onCompleted: data => {}
          })
            .then(res => {
              console.log(res);
              console.log("COMPLETED");
              setInProgress(false);
              // setIsUpdated(true);
              setOldPassword("");
              setNewPassword("");
              track("DASHBOARD_SETTINGS_PASSWORD_CHANGE_SUCCESS");
              return { success: true };
            })
            .catch(e => {
              console.log(e.message);
              setInProgress(false);
              setErrorMessage("Invalid Password");
              setOldPassword("");
              setNewPassword("");
              track("DASHBOARD_SETTINGS_PASSWORD_CHANGE_FAILURE", {
                message: "Invalid Password"
              });
              return { success: false };
            });
        }}
        className={inProgress ? "disabled" : ""}
      >
        Save password
      </SettingsButton>
      {!passwordReset ? (
        <div
          className={classnames("mt-6", {
            flex: !isMobile,
            "text-center text-sm": isMobile
          })}
        >
          <p
            className={classnames(
              { "text-center": isMobile },
              { "mr-1": !isMobile }
            )}
          >
            Can’t remember your current password?
          </p>
          <p
            className={classnames("text-green-primary cursor-pointer", {
              "text-center": isMobile
            })}
          >
            <button type="button" onClick={triggerResetEmail}>Reset your password by email</button>
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($old_password: String!, $new_password: String!) {
    updatePassword(old_password: $old_password, new_password: $new_password) {
      email
    }
  }
`;

export default Password;
